/* import __COLOCATED_TEMPLATE__ from './none-category-row.hbs.js'; */
import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import discourseComputed from "discourse/lib/decorators";
import CategoryRowComponent from "select-kit/components/category-row";
const NoneCategoryRow = dt7948.c(class NoneCategoryRow extends CategoryRowComponent {
  badgeForCategory(category) {
    return htmlSafe(categoryBadgeHTML(category, {
      link: false,
      allowUncategorized: true,
      hideParent: true
    }));
  }
  static {
    dt7948.n(this.prototype, "badgeForCategory", [discourseComputed("category")]);
  }
}, [classNames("none category-row")]);
export default NoneCategoryRow;